import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Helper from '../../helpers';
import axios from 'axios';
import Config from '../../config';
import { Grid, Card, CardContent, CircularProgress } from '@mui/material';

interface ShopifySettings {
    ShopifyStoreName?: string;
    [key: string]: unknown;
}

interface ShopifyAuthState {
    loading: boolean;
    error: boolean;
}

const connectToShopify = (properties: ShopifySettings): void => {
    let clientId = '9772fd2a906b2e5fee1b544b0ebabd12';
    let shop = properties.ShopifyStoreName;
    let scopes = 'write_inventory,read_orders,write_orders,read_products,write_products,read_fulfillments,write_fulfillments,read_merchant_managed_fulfillment_orders,read_third_party_fulfillment_orders,read_assigned_fulfillment_orders,write_merchant_managed_fulfillment_orders,write_third_party_fulfillment_orders,write_assigned_fulfillment_orders,read_locations,read_customers';
    let redirect_uri = `${window.location.protocol}//${window.location.host}/oauth/shopify`;
    let nonce = new Date().getTime().toString();
    let url = `https://${shop}.myshopify.com/admin/oauth/authorize?client_id=${clientId}&scope=${scopes}&redirect_uri=${redirect_uri}&state=${nonce}`;
    window.location.href = url;
}

class ShopifyAuth extends Component<{}, ShopifyAuthState> {
    state: ShopifyAuthState = {loading: true, error: false}
    async componentDidMount(){
        try{
            let qs: Record<string, string> = new Helper().queryString();
            if(qs.error){
                // Provider denial (e.g. ?error=access_denied) — do NOT fall through to
                // the initiate path; re-initiating bounced the user back into consent
                // in a loop. Show the error UI.
                this.setState({error: true, loading: false});
            } else if(!qs.code && qs.shop){
                try{
                    let values = {ShopifyStoreName: qs.shop.split('.')[0]};
                    await axios.put(Config.api + `/odata/Company/Functions.SetSystemSettings?system=Shopify`, values);
                    connectToShopify(values);
                }catch{
                    // Failed settings save → error UI (not an unhandled rejection + spinner).
                    this.setState({error: true, loading: false});
                }
            } else if(qs.code){
                try{
                    await axios.get(Config.api + `/odata/Company/Functions.ConnectShopify?code=${window.encodeURIComponent(qs.code)}`);
                    this.setState({loading: false});
                }catch{
                    this.setState({error: true, loading: false});
                }
            } else {
                // Neither code, shop, nor error (e.g. a bare /oauth/shopify bookmark) —
                // nothing to do; show the error UI instead of a permanent spinner.
                this.setState({error: true, loading: false});
            }
        }catch{
            // Malformed query (e.g. ?code=% makes queryString/decodeURIComponent throw)
            // — don't leave an unhandled rejection + stuck spinner.
            this.setState({error: true, loading: false});
        }
    }
    render(){
        if(this.state.loading){
            return <Grid container spacing={2}>
                <Grid size={{ md: 12 }}>
                    <Card>
                    <div style={{position: 'relative', marginTop: '1em'}}>
                        <CircularProgress variant={'indeterminate'} size='8em'/>
                    </div>
                    <div style={{padding: '1em'}}>{'Completing Shopify authentication...'}</div>
                    </Card>
                </Grid>
            </Grid>;
        } else if (this.state.error){
            return <Grid container spacing={2}>
                <Grid size={{ md: 12 }}>
                    <Card>
                    <CardContent>
                    Authentication failed. Please try to connect again from the <Link to='/connections'>settings page</Link>.
                    </CardContent>
                    </Card>
                </Grid>
            </Grid>;
        }
        return <Grid container spacing={2}>
            <Grid size={{ md: 12 }}>
                <Card>
                <CardContent>
                Shopify authentication complete!
                </CardContent>
                </Card>
            </Grid>
        </Grid>;
    }
}

export default ShopifyAuth;
export {connectToShopify}
